/* eslint-disable max-len */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";
import { CognitoData } from "../../../CommonMethods/CognitoData";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const AcademicYear = createAsyncThunk('academic-years', async (searchParams) => {
    const user = await CognitoData();
    let branch_id = ""
    if(user.idToken.payload["custom:user_type"] === "institution-user" || user.idToken.payload["custom:user_type"]==='institution-admin') {
        branch_id = JSON.parse(localStorage.getItem('branch_details')).id
    } else {
        branch_id = user.idToken.payload["custom:branch_id"]
    }
    let res = await dataService.GetAPI(`academic-years?branch_id=${branch_id.toString()}&${(searchParams.toString())}`);
    return res
})
const AcademicYearSlice = createSlice({

    name: 'Classes-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        }

    },
    extraReducers: {
        [AcademicYear.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [AcademicYear.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [AcademicYear.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading } = AcademicYearSlice.actions;
export default AcademicYearSlice.reducer